/**
 * Reload once when a lazily-imported chunk fails to load.
 *
 * A production deploy rotates Vite's hashed chunk filenames. A browser tab
 * loaded BEFORE the deploy still references the old chunk names, so navigating
 * to a lazy route fails to import the (now-missing, served as index.html) chunk
 * with "error loading dynamically imported module". Reloading picks up the fresh
 * build. Guarded by a timestamp so a genuinely-broken chunk can't loop the page.
 */
export function installPreloadErrorRecovery(): void {
  if (typeof window === 'undefined') return;
  window.addEventListener('vite:preloadError', (event) => {
    const KEY = 'vite:preloadError:last';
    const now = Date.now();
    const last = Number(sessionStorage.getItem(KEY) ?? '0');
    // Already reloaded very recently and still failing => let the error surface
    // (something is genuinely broken) instead of reload-looping.
    if (now - last < 10_000) return;
    sessionStorage.setItem(KEY, String(now));
    event.preventDefault();
    window.location.reload();
  });
}
